import { createFileRoute } from '@tanstack/react-router'
import { DummyRequests } from '@/features/dummy-requests'

export const Route = createFileRoute('/_authenticated/dummy-requests/')({
  component: DummyRequests,
})
